export const ID_ENTITY_MOTIVE_OBSERVED = 2;

export const TabIds = {
  TRANSACTION: 'transaction',
  STATUS: 'transaction_status',
  IMMEDIATE_TRANSACTION: 'immediate_transaction',
};

export const tabTitles = {
  [TabIds.TRANSACTION]: 'Alta de trámite',
  [TabIds.STATUS]: 'Estado de trámites',
  [TabIds.IMMEDIATE_TRANSACTION]: 'Registro de pacientes internados / Censo',
};

export const TRANSACTION_TYPES = {
  MEDICAL_AUTHORIZATION: 'C',
  DENTAL: '1',
  DISABILITY: '9',
  SCHEDULED_TRANSFER: '10',
};

export const AUTHORIZATION_TYPES = {
  BENEFIT_PRACTICE_SURGERY: 'Prestacion, Practica y/o Cirugia',
};
